import { SingleValue } from 'react-select';

import { Deployment } from 'types/deployment';
import { DataWidgetFiltersInput } from 'dashboards/types/filter';

import { useDeployments } from 'deployments/hooks/useDeployments';

import { DeploymentSelect } from 'deployments/components/DeploymentSelect/DeploymentSelect';

import { Placeholder } from './SuggestionInput';
import { filterIds } from '../service';
import { useDataWidgetFiltersInputState } from '../context';

type DeploymentFilterInputProps = Pick<DataWidgetFiltersInput, 'id' | 'value'>;

export function DeploymentFilterInput({
  id,
  value,
}: DeploymentFilterInputProps) {
  const { filters, updateFilter } = useDataWidgetFiltersInputState();

  const deploymentIds = filterIds('deployment_id', filters);

  const { data: deployments, isInitialLoading } = useDeployments({
    params: { deployment_ids: deploymentIds, limit: deploymentIds.length },
    enabled: Boolean(deploymentIds.length),
    keepPreviousData: true,
  });

  if (!deployments && isInitialLoading) {
    return Placeholder;
  }

  function handleDeploymentChange(deployment: SingleValue<Deployment>) {
    if (!deployment) {
      return;
    }

    updateFilter(id, { value: deployment.id });
  }

  return (
    <DeploymentSelect
      defaultValue={deployments?.data.find(({ id }) => id === value)}
      onChange={handleDeploymentChange}
      styles={{
        menu: (provided) => ({
          ...provided,
          width: 'auto',
        }),
      }}
    />
  );
}
